// extracted by mini-css-extract-plugin
export var addonName = "style-module--addonName--32e74";
export var available = "style-module--available--2bdc3";